import { Component, output } from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'search-filter',
    imports: [FormsModule],
    templateUrl: './search-filter.component.html',
    styleUrl: './search-filter.component.scss'
})
export class SearchFilterComponent {
  searchTerm = '';
  readonly searchChanged = output<string>();

  clearSearch() {
    this.searchTerm = '';
    this.searchChanged.emit('');
  }
}
